module.exports = __webpack_public_path__ + "static/grassy-3-a032b22ac28335dfc3409e69ef44aa14.jpg";